<template>
  <div :class='$style.container'>
    <Title :num='num' :time='time' :title='title' />
    <div :class='$style.content'>
      <slot />
    </div>
  </div>
</template>

<script>
import Title from "./Title";
export default {
  name: "Container",
  components: { Title },
  props: {
    num: String,
    title: String,
    time: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
}
.container ~ .container {
  margin-top: 72px;
}
.content {
  margin-top: 36px;
}
</style>